import {
  CaseApi,
  CasesWithVitalSignsFilterDTOSortDirectionEnum,
  type CasesWithVitalSignsFilterDTOHeartRateRange,
  MedicalFieldApi,
  type RadiologyImageMetadataResponse,
  type GetCaseResponse,
  type GetMedicalFieldsResponse,
  type CasesWithVitalSignsFilterOptionsResponse,
  RadiologyCasesApi,
  AllCaseOrderOptionsDTO
} from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'

export class CaseService {
  static readonly caseApi = new CaseApi(globalApiConfig)
  static readonly medicalFieldApi = new MedicalFieldApi(globalApiConfig)
  static readonly radiologyCasesApi = new RadiologyCasesApi(globalApiConfig)

  static async getMedicalFields(): Promise<GetMedicalFieldsResponse> {
    return (await CaseService.medicalFieldApi.getMedicalFields()).data
  }

  static async getCases({ offset = 0, limit = 100 }: { offset?: number; limit?: number } = {}) {
    return (await CaseService.caseApi.getCases(offset, limit)).data
  }

  static async getCasesWithVitalSigns({
    offset = 0,
    limit = 100,
    sortBy,
    sortDirection,
    ecmo,
    impella,
    dialysis,
    ventilation,
    vasopressors,
    wardIds,
    hospitalIds,
    departmentIds,
    temperatureRange,
    heartRateRange,
    oxygenSaturationRange,
    lactateRange,
    phRange,
    potassiumRange,
    hemoglobinRange
  }: {
    offset?: number
    limit?: number
    sortBy?: AllCaseOrderOptionsDTO
    sortDirection?: CasesWithVitalSignsFilterDTOSortDirectionEnum | null
    ecmo?: boolean | null
    impella?: boolean | null
    dialysis?: boolean | null
    ventilation?: boolean | null
    vasopressors?: boolean | null
    wardIds?: Array<string>
    hospitalIds?: Array<string>
    departmentIds?: Array<string>
    temperatureRange?: CasesWithVitalSignsFilterDTOHeartRateRange
    heartRateRange?: CasesWithVitalSignsFilterDTOHeartRateRange
    oxygenSaturationRange?: CasesWithVitalSignsFilterDTOHeartRateRange
    lactateRange?: CasesWithVitalSignsFilterDTOHeartRateRange
    phRange?: CasesWithVitalSignsFilterDTOHeartRateRange
    potassiumRange?: CasesWithVitalSignsFilterDTOHeartRateRange
    hemoglobinRange?: CasesWithVitalSignsFilterDTOHeartRateRange
  } = {}) {
    return (
      await CaseService.caseApi.getCasesWithVitalSigns({
        limit,
        offset,
        sortBy,
        sortDirection,
        ecmo,
        impella,
        dialysis,
        ventilation,
        vasopressors,
        wardIds,
        hospitalIds,
        departmentIds,
        temperatureRange,
        heartRateRange,
        oxygenSaturationRange,
        lactateRange,
        phRange,
        potassiumRange,
        hemoglobinRange
      })
    ).data
  }

  static async getCasesWithVitalSignsFilterOptions(): Promise<CasesWithVitalSignsFilterOptionsResponse> {
    return (await CaseService.caseApi.getCasesWithVitalSignsFilterOptions()).data
  }

  static async getCase(
    id: string,
    shareCode: string | undefined = undefined
  ): Promise<GetCaseResponse> {
    return (await CaseService.caseApi.getCase(id, shareCode)).data
  }

  // FIXME: This is not used anywhere. Remove it?
  static async createEmergency(id: string): Promise<void> {
    await CaseService.caseApi.createEmergency(id)
  }

  static async getRadiologyImagesMetadata(
    caseId: string,
    shareCode?: string
  ): Promise<RadiologyImageMetadataResponse> {
    return (await CaseService.radiologyCasesApi.getRadiologyImagesMetadata(caseId, shareCode)).data
  }
}
